<script setup lang="ts"></script>

<template>
  <div class="base">
    <img src="@/assets/logo-big.png" class="icon" />
    <div class="title-col">
      <div class="title">你好，我是你的AI助手</div>
      <div class="title2">
        我可以帮你写代码、读文件、写作各种创意内容，请把你的任务交给我吧~
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.base {
  width: 100%;
  height: 96px;
  border-radius: 10px;
  opacity: 1;
  align-items: center;
  padding-left: 20px;
  padding-right: 20px;
  gap: 16px;

  /* 自动布局 */
  display: flex;

  background: #f0f3ff;

  .icon {
    width: 52px;
    height: 52px;
  }
  .title-col {
    display: flex;
    gap: 4px;
    flex-direction: column;
    .title {
      font-size: 15px;
      font-weight: bold;
    }
    .title2 {
      font-size: 12px;
      color: #666666;
    }
  }
}
</style>
